import React from 'react';
import './AboutStoryIntro.css';

const AboutStoryIntro = () => (
  <section className="about-story-intro">
    <div className="about-story-intro__inner">
      <span className="about-story-intro__tag">OUR STORY</span>
      <h2 className="about-story-intro__heading">
        Work you can count on,
        <span className="about-story-intro__heading-accent"> from people who care.</span>
      </h2>
      <div className="about-story-intro__body">
        <p>
          Fresh Start was founded by Jennifer Cox Mendez with the clear intention to build a landscaping
          company that treated every client&apos;s outdoor space with the same care she would give her own.
          That intention shaped everything that followed. Over 20 years, the company grew from that single
          commitment into a close-knit team of people who share the same values: do the work properly,
          communicate honestly, and leave every yard better than you found it.
        </p>
        <p>
          What makes Fresh Start different is not just the quality of the work, it is the relationship behind
          it. We take the time to understand what you actually want, communicate clearly every step of the
          way, and show up the way we said we would. For many of our clients, that consistency is what keeps
          them calling us back season after season.
        </p>
      </div>
    </div>
  </section>
);

export default AboutStoryIntro;
